<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="listTableItems"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalRecords"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [5, 10, 20, 50],
            }"
        >
            <template v-slot:[`item.isActive`]="{ item }">
                <v-chip
                    :color="getColor(item.isActive)"
                    pill
                    dark
                    small
                    class="status-column"
                >
                    {{ getTextState(item.isActive) }}
                </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom v-if="item.fromEntityPack">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on"
                            style="background-color: black"
                            class="circle mr-2"
                        >
                            <span
                                class="v-chip__content"
                                style="
                                    font-size: 9px !important;
                                    color: white;
                                    margin-left: 5px;
                                "
                            >
                                PR
                            </span>
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.components.datatable-normal-pack.from-entity-pack"
                        )
                    }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.toEntityPack">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on"
                            style="background-color: red"
                            class="circle mr-2"
                        >
                            <span
                                class="v-chip__content"
                                style="
                                    font-size: 9px !important;
                                    color: white;
                                    margin-left: 3px;
                                "
                            >
                                DR
                            </span>
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.components.datatable-normal-pack.to-entity-pack"
                        )
                    }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="userAuth.roleId == 1">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="packEdit(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/edit_pencil.svg"
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.components.datatable-normal-pack.edit-pack"
                        )
                    }}</span>
                </v-tooltip>
                <v-tooltip
                    bottom
                    v-if="userAuth.roleId == 2"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="$emit('transfer-balance', item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/edit_pencil.svg"
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span>{{
                        $t(
                            "backoffice.modules-management.vrm.config-access.transfer-balance.transfer-pack"
                        )
                    }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="userAuth.roleId == 1">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="downloadBtn(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/download-button.svg"
                                onload="SVGInject(this)"
                                width="10"
                                height="10"
                                style="margin-left: 5px"
                            />
                        </span>
                    </template>
                    <span>{{ $t("backoffice.actions.download") }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.creationDateTime`]="{ item }">
                <span>
                    {{ item.creationDateTime | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                <span>
                    {{ item.endDate | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:[`footer.prepend`]>
                <div class="d-flex flex-column">
                    <v-chip
                        class="ml-8 mt-1"
                        :class="index == balance.length - 1 ? 'mb-1' : ''"
                        v-for="(item, index) in balance"
                        :key="item.name"
                    >
                        <span class="span-title-footer">{{
                            `${item.name} | ${$t(
                                "backoffice.modules-management.vrm.components.datatable-normal-pack.actual-balance"
                            )}`
                        }}</span>
                        <span class="span2-title-footer">{{ item.value }}</span>
                    </v-chip>
                </div>
            </template>
        </v-data-table>
        <v-col class="mt-1">
            <v-btn
                fab
                dark
                x-small
                color="var(--v-primary-base)"
                @click="onClickNormalPack"
                v-if="userAuth.roleId != 3 && billingTypeId != 4 && ifBalance"
            >
                <v-icon dark> mdi-plus </v-icon>
            </v-btn>
            <span
                @click="onClickNormalPack"
                class="ml-3 span-packs"
                v-if="userAuth.roleId != 3 && billingTypeId != 4 && ifBalance"
                >{{
                    $t(
                        "backoffice.modules-management.vrm.new-access.normal-pack.create-new-pack"
                    )
                }}</span
            >

            <!-- <v-btn fab dark x-small color="var(--v-primary-base)" @click="onClickUserList" class="ml-8">
                <v-icon dark>
                    mdi-account
                </v-icon>
            </v-btn>
            <span @click="onClickUserList" class="ml-3 span-packs">{{ !seeUsersList ? $t('backoffice.modules-management.vrm.components.datatable-normal-pack.see-user-list') : $t('backoffice.modules-management.vrm.components.datatable-normal-pack.hide-user-list')}}</span> -->
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listTableItems: null,
        seeUsersList: Boolean,
        billingTypeId: 0,
        searchCount: Number,
        totalRecords: Number,
        ifBalance: Boolean,
        balance: Array,
        accessType: String,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.invoice"
                    ),
                    value: "invoiceNumber",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.vrm.table.pack-type"
                    ),
                    value: "packType",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.access-type-form.vehicle-typology"
                    ),
                    value: "packVehicleTipology",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.qty"
                    ),
                    value: "chargedBalance",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.current-balance"
                    ),
                    value: "currentBalance",
                    align: "start",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.status"
                    ),
                    value: "isActive",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.create-date"
                    ),
                    value: "creationDateTime",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.end-date"
                    ),
                    value: "endDate",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.datasource"
                    ),
                    value: "dataSource",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.created-by"),
                    value: "createdBy",
                    sortable: false,
                    align: "center",
                    class: "header-table-color",
                },
                 {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-normal-pack.headers.obs"
                    ),
                    value: "observations",
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        };
    },
    computed: {
        userAuth() {
            return this.$store.getters["auth/getState"];
        },
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTableDatatableNormalPack", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTableDatatableNormalPack", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
        deep: true,
    },
    methods: {
        getColor(status) {
            if (status == true) return "green";
            else if (status == false) return "red";
            else return "orange";
        },
        getTextState(status) {
            if (status == true)
                return this.$t("backoffice.general.active-status");
            else if (status == false)
                return this.$t("backoffice.general.inactive-status");
        },
        packEdit(item) {
            this.$emit("pack-edit", item);
        },
        downloadBtn(item) {
            this.$emit("pack-download", item);
        },
        onClickNormalPack() {
            this.$emit("normal-pack-datatable-btn");
        },
        // onClickUserList() {
        //     this.$emit('user-list')
        // }
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#content-backoffice {
    table {
        thead {
            tr {
                th {
                    border: 0;
                    
                    &.header-table-color {
                        background-color: #f2f2f2 !important;
                        color: #9e9d9d !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 12px !important;
            padding: 2px;
        }
    }
    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }
    .circle-minor {
        background-color: #e6e5e5;
        width: 20px;
        height: 14px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }
    .span-title-footer,
    .span2-title-footer {
        /* text-transform: uppercase; */
        font-size: 16px;
        color: #4b4849;
        letter-spacing: 0px;
        opacity: 1;
    }
    .span-title-footer {
        /* margin-left: 2rem; */
    }
    .span2-title-footer {
        margin-left: 0.4rem;
    }
}
</style>
